import fi from './fi.json';
import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import sv from './sv.json';
import et from './et.json';

export default {
  fi,
  en,
  de,
  fr,
  it,
  nl,
  sv,
  et
};
